/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var customSwitcherBox = {

    engraveLimit: undefined,
    showExtraFields: undefined,
    primaryInputLabel: undefined,
    secondaryInputLabel: undefined,
    thirdInputLabel: undefined,
    propertiesMultiple: undefined,
  	map: undefined,


    initVariables() {
        if ($(".custom-switcher-content-wrapper").hasClass("limit-4807831060541")) {

            customSwitcherBox.ngraveLimit = 12;
        } else if ($('.engrave-text-switch-cont').hasClass('text-input-limited')) {
            customSwitcherBox.engraveLimit = 25;
        } else {
            customSwitcherBox.engraveLimit = 22;
        }

        if ($(".custom-switcher-content-wrapper").hasClass("multiple-engravings")) {

            customSwitcherBox.showExtraFields = true;
            customSwitcherBox.primaryInputLabel = "Front engraving";
            customSwitcherBox.secondaryInputLabel = "Back engraving";
            customSwitcherBox.propertiesMultiple = "Front engraving";
        } else {
            customSwitcherBox.showExtraFields = false;
            customSwitcherBox.primaryInputLabel = "Engrave text";
            customSwitcherBox.propertiesMultiple = "Text";
        }
        if ($(".productOption--ENGRAVING").hasClass("barEngraveOptions")) {
            customSwitcherBox.primaryInputLabel = "Front engraving";
            customSwitcherBox.secondaryInputLabel = "Left side engraving";
            customSwitcherBox.thirdInputLabel = "Right side engraving";
            customSwitcherBox.propertiesMultiple = "Front engraving";
        } else if ($(".productOption--ENGRAVING").hasClass("plateEngraveOptions")) {
            customSwitcherBox.primaryInputLabel = "Front engraving";
            customSwitcherBox.secondaryInputLabel = "Back engraving";
            customSwitcherBox.propertiesMultiple = "Front engraving";
        } else {
            customSwitcherBox.primaryInputLabel = "Engrave text";
            customSwitcherBox.propertiesMultiple = "Text";
        }
    },

  initEngravingFontChooser() {
        $(".engrave-font-chooser-item").on("click", function() {
          
            let container = $(this).closest('form');

        
            container.find('.engrave-font-chooser-item').not(this).removeClass('font-selected');
            $(this).addClass("font-selected");
            container.find("#engraving-font").val($(this).data("font"));

          	$('.open-product').find('.prop-type--Font span').html($(this).data("font"))
            container.find(".input-container-switch, .engrave-text-switch-cont").removeClass(function(index, css) {
                return (css.match(/\bengrave-font\S+/g) || []).join(' '); // removes anything that starts with "itemnx"
            });
            var fontClass = $(this).data("font").replace(/\s+/g, '-').toLowerCase();
            container.find('.input-container-switch, .engrave-text-switch-cont').addClass("engrave-font-" + fontClass);
          


            if ($('.product-custom-switcher-box').hasClass('mycircle-necklace-main')){
                var mainfont =  $(this).attr('data-font');
                //$('#line-item-dynamic #engraving-font').val(mainfont);
                    if (container.find('.engrave-text-switch-cont').hasClass("engrave-font-standard")) {
                    container.find(".engrave-font-disc-text").hide();
                    container.find(".input-sub").show();
                    } else {
                    container.find(".engrave-font-disc-text").show();
                    container.find(".input-sub").hide();
                    }
            }else{
              if (container.find('.input-container-switch').hasClass("engrave-font-standard")) {
                    container.find(".engrave-font-disc-text").hide();
                    container.find(".input-sub").show();
                    } else {
                    container.find(".engrave-font-disc-text").show();
                    container.find(".input-sub").hide();
                    }
                  drawStack();
            }
        });
    },

    initButtons() {
        $(document).ready(function() {
            if (window.location.href.indexOf("?morse") > -1) {
                $(".morse-btn").click();
            } else if (window.location.href.indexOf("?text") > -1) {
                $(".text-btn").click();
            } else if (window.location.href.indexOf("?coords") > -1) {
                $(".coords-btn").click();
            }

        });

        $(".coords-btn").click(function() {
            let container = $(this).closest('form');
            container.find("#morse-code").attr('name', '');
            container.find("#engraving-font").attr('name', 'properties[Font]');

            container.find(".coordinates-variant").show();
            container.find(".morse-variant").hide();
            container.find(".engrave-text-cont").hide();
            container.find(".engrave-font-chooser-wrapper").show();

          
            container.find(".coordinates-variant").addClass('active_bottom');
            container.find(".morse-variant").removeClass('active_bottom');
            container.find(".engrave-text-cont").removeClass('active_bottom');
          	
          	container.closest('.custom-bundle-form-item').find('.prop-type--Morse.code').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Text').remove();


            container.find(".text-engrave").removeClass("line-item-property__field");
            container.find("#morse-code").attr('name', '');
            container.find(".text-engrave-left").removeClass("line-item-property__field");
            container.find(".morse-property").removeClass("line-item-property__field");
            container.find(".text-engrave:not(.multiple-eng-hide-spec) input").attr('name', '');
          
          	container.find(".text-input-limit .text-engrave:not(.multiple-eng-hide-spec) textarea").attr('name', '');
            container.find(".text-engrave-left input").attr('name', '');
            container.find(".maps-latitude input").attr('name', 'properties[Latitude]');
            container.find(".maps-longitude input").attr('name', 'properties[Longitude]');


            container.find(".text-btn").removeClass("active-switcher");
            container.find(".coords-btn").addClass("active-switcher");
            container.find(".morse-btn").removeClass("active-switcher");
            container.find(".dynamic-landing-heading-hide").show();
            container.find(".dynamic-landing-heading-edit:not(.land-head-no-change)").text('4. Select your color')

        });


        $(".text-btn").click(function() {
            let container = $(this).closest('form');
            container.find(".maps-latitude input").attr('name', '');
            container.find(".maps-longitude input").attr('name', '');
            container.find(".text-engrave").addClass("line-item-property__field");
            container.find(".text-engrave-left").addClass("line-item-property__field");

			container.closest('.custom-bundle-form-item').find('.prop-type--Latitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Longitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Morse.code').remove();
          

            container.find(".text-engrave:not(.multiple-eng-hide-spec) input").attr('name', 'properties[' + customSwitcherBox.propertiesMultiple + ']');
			container.find(".text-input-limit .text-engrave:not(.multiple-eng-hide-spec) textarea").attr('name', 'properties[' + customSwitcherBox.propertiesMultiple + ']');
            container.find(".morse-property").removeClass("line-item-property__field");
            container.find(".coordinates-variant").hide();
            container.find(".morse-variant").hide();
            container.find(".engrave-text-cont").show();
          	container.find("#morse-code").attr('name', '');
            container.find(".engrave-font-chooser-wrapper").show();

            container.find(".coordinates-variant").removeClass('active_bottom');
            container.find(".morse-variant").removeClass('active_bottom');
            container.find(".engrave-text-cont").addClass('active_bottom');

            container.find(".dynamic-landing-heading-hide").show();
            container.find(".dynamic-landing-heading-edit:not(.land-head-no-change)").text('4. Select your color')
            container.find(".text-btn").addClass("active-switcher");
            container.find(".coords-btn").removeClass("active-switcher");
            container.find(".morse-btn").removeClass("active-switcher");

            container.find('.text-input-limit').keyup(function(e) {
                console.log("text-input running");
                if (e.keyCode === 8) return; // Backspace
                var new_stuff = $(this).val();
                new_stuff = new_stuff.replace(/[\n\r]+/g, ""); // clean out newlines, so we dont get dups!
                new_stuff = new_stuff.replace(/(.{12})/g, "$1\r");
                $(this).val(new_stuff);
            });
            container.find("#line-item-dynamic input").attr('name', 'properties[Font]');

        });

        $(".morse-btn").click(function() {
            let container = $(this).closest('form');
            container.find(".maps-latitude input").attr('name', '');
            container.find(".maps-longitude input").attr('name', '');

            container.find(".coordinates-variant").hide();
            container.find(".morse-variant").show();
            container.find(".engrave-text-cont").hide();

            container.find(".coordinates-variant").removeClass('active_bottom');
            container.find(".morse-variant").addClass('active_bottom');
            container.find(".engrave-text-cont").removeClass('active_bottom');
          
          	container.closest('.custom-bundle-form-item').find('.prop-type--Latitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Longitude').remove();
          	container.closest('.custom-bundle-form-item').find('.prop-type--Text').remove();

            container.find(".text-engrave").removeClass("line-item-property__field");
            container.find(".text-engrave-left").removeClass("line-item-property__field");
            container.find(".engrave-font-chooser-wrapper").hide();

            container.find("#line-item-dynamic input").attr('name', '');
            container.find('.barEngraveExtraOpt').attr('name', '');
            container.find('.text-engrave-left input').attr('name', '');
            container.find('#text-engrave').attr('name', '');
            container.find(".dynamic-landing-heading-hide").hide();
            container.find(".dynamic-landing-heading-edit").text('3. Select your color')
            container.find("#morse-code").attr('name', 'properties[Morse code]');
            container.find(".morse-property").addClass("line-item-property__field");

            container.find('.morse-variant').show();
            container.find(".text-btn").removeClass("active-switcher");
            container.find(".coords-btn").removeClass("active-switcher");
            container.find(".morse-btn").addClass("active-switcher");

        });
    }
};

       function lowStockCounter(){
          var minNumber = 59;
          var maxNumber = 198

          var randomNumber = randomNumberFromRange(minNumber, maxNumber);

          function randomNumberFromRange(min,max)
          {
              return Math.floor(Math.random()*(max-min+1)+min);
          }
          console.log("stockCOunt", randomNumber);
          $(".low-stock-notice span").html(randomNumber);
        }

function photoGuideModal() {
  $('.guide-btn').click( function(){
    console.log("test");
    $('.photo-guide-modal').show();
    
  });
    $('.photo-guide-close').click( function(){
    
    $('.photo-guide-modal').hide();
    
  });
}

function titoCampDetection() {
 
  if (window.location.href.indexOf("?tiktok") > -1) {
     console.log("Tiktok campaign triggered");
     $('body').addClass("tiktok-campaign");
    
    sessionStorage.setItem("tiktokCamp", "yes");
  } 
  
}


$(document).ready(function(){
  
  if(sessionStorage.getItem("tiktokCamp") == "yes"){
     console.log("Tiktok campaign triggered");
     $('body').addClass("tiktok-campaign");
    
  } 
    console.log("viewcart is active and running")
         	if (window.location.href.indexOf("?viewcart=true") > -1) {
            console.log("Viewcart is in URL");
            $('.Drawer--Open').get(0).click()


          	} 

  
  lowStockCounter()
  
  photoGuideModal()
  
  titoCampDetection()
  if (window.closed) {
    sessionStorage.setItem("tiktokCamp", "no")
    }
  /*$(window).on("unload", function(){
    
    sessionStorage.setItem("tiktokCamp", "no")
    
  });*/
  
  
  

});

// $(document).on('click', '#findLocationBtn', function(){
//  var values =  $(this).closest('#search').find('div#geocoder input#mapbox-search').val();
//  const myArray = values.split(",").pop();
//   alert(myArray);
// });